module.exports = __webpack_public_path__ + "h5/img/honghao.9cfb6253.png";